<template>
  <div class="hello">
    <div class="subTitle">彝良天立学校</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'yltlxx',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM7dtgjzXl89IMHSXiehabXYjX4jV3gxX5ks7colbU6UYXTHeoAShm3k0eWjyiNiLom27t3MVYSEeyNieKCgGv/eAFt2o5VQyegb2Vt7JmFxVXhrYkF1G0epOOUMyHoPV8aLQti+Sa2T1p68Q/DccrRk='
        },
        {
          label: '餐费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM0vMUcPO0wQvanX8nKDPzXtXkMuWCbuSxub8xMoQ4mtcirtwY2G5/yOHlkvJBl5ZofW+3DS9EYydVQNxBZ2SSBiVD6egtD2XAY1jZcTd15XglVWSGtaf5Wrw0Foq9VNzD6jN/dBMPYPPYQIYCTAf+u4='
        },
        {
          label: '素养服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmMx6/C92De3Jyn3O3yVG3knZoeKTHrRztFi9CQfwro0N+dQNp8ByTpB6Ewo/VPknOWZjFkApc9VAh6DCsCFgXtSdhhWZmahLfBdKB8kSKtFNOMpct6g5t0By++aOfBGuF2AMZOkVtTzk2HtfbrPkWpkqKG1chXxsIOZn4uA68RE/D'
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmMyV592ramLRo9a64y542bSSfyGfO1PplN6gkIH5lgsNURbZ5vGS4XroyABmBN/US9ug88OvnfF4Ag4F2aSbldKsKFNun3mArFLULeBIQD75P0JePHTclufZ4NMshSYOxrVQzdKE82ISs3kW0HZxlZDc='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '彝良天立学校';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

